import React from 'react';
import PropTypes from 'prop-types';
import logger from 'ws-scripts/modules/logger';

/**
 * ErrorBoundary — catches render errors in the NavigationDrawer tree.
 *
 * On error: renders null (the SSR nav links below the React tree remain visible).
 * Errors are logged to console.error with a namespaced prefix.
 */
class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, info) {
		logger.error(
			'[ws-navigation-drawer] ErrorBoundary caught:',
			error,
			info
		);
	}

	render() {
		if (this.state.hasError) return null;
		return this.props.children;
	}
}

ErrorBoundary.propTypes = {
	children: PropTypes.node.isRequired
};

export default ErrorBoundary;
